export const privacyTranslations = {
  privacyPolicy: {
    title: "Privacy Policy",
    description: "Your privacy is important to us. This policy explains how we collect, use, and protect your information.",
    lastUpdated: "Last updated:",
    sections: {
      informationCollection: {
        title: "Information We Collect",
        personalInfo: {
          title: "Personal Information",
          content: "We collect information you provide directly to us, such as when you create an account, subscribe to our newsletter, or contact us for support. This may include your name, email address, phone number, and professional information."
        },
        usageInfo: {
          title: "Usage Information",
          content: "We automatically collect information about how you use our services, including your IP address, browser type, pages visited, and interaction patterns to improve our services."
        }
      },
      informationUse: {
        title: "How We Use Your Information",
        items: [
          "Provide, maintain, and improve our testing services and community platform",
          "Send you technical notices, updates, and marketing communications",
          "Respond to your comments, questions, and provide customer support",
          "Monitor and analyze trends, usage, and activities in connection with our services"
        ]
      },
      informationSharing: {
        title: "Information Sharing and Disclosure",
        intro: "We do not sell, trade, or otherwise transfer your personal information to third parties without your consent, except in the following circumstances:",
        items: [
          "Service providers who assist in our operations",
          "Legal compliance and protection of rights",
          "Business transfers or mergers",
          "With your explicit consent"
        ]
      },
      dataSecurity: {
        title: "Data Security",
        content: "We implement appropriate technical and organizational security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the internet is 100% secure."
      },
      yourRights: {
        title: "Your Rights",
        intro: "You have the right to:",
        items: [
          "Access and update your personal information",
          "Request deletion of your data",
          "Opt-out of marketing communications",
          "Data portability"
        ]
      },
      contact: {
        title: "Contact Us",
        content: "If you have any questions about this Privacy Policy, please contact us at:",
        details: {
          email: "Email: privacy@qualitynexus.com",
          address: "Address: Quality Nexus Privacy Team",
          businessAddress: "[Your Business Address]"
        }
      }
    }
  }
};